import gql from "graphql-tag"

const UPDATE_ADDRESS_MODIFICATION = gql`
  mutation updateOrderModificationAddresses($modificationId: ID!, $input: InputOrderModificationAddresses!) {
    Order {
      updateOrderModificationAddresses(modificationId: $modificationId, input: $input) {
        ... on OrderModificationAddresses{
          id
        }
      }
    }
  }
`

export default UPDATE_ADDRESS_MODIFICATION
